var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("separator", {
        staticClass: "mb-separation",
        attrs: { text: "Resultado de Contratos" }
      }),
      _vm.userHasPermissions("provider.contract.add")
        ? _c(
            "callout",
            {
              staticClass: "mb-3",
              attrs: {
                "border-color": "primary-1",
                "class-main": "py-3",
                "has-toggle": false
              }
            },
            [
              _c(
                "div",
                { staticClass: "row d-flex justify-content-center" },
                [
                  _c("action-button", {
                    staticClass: "border w-40 btn",
                    attrs: {
                      i: "fas fa-file-plus color-primary-1",
                      text: "Presione aquí para añadir contrato"
                    },
                    on: { click: _vm.onAddContractHandler }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.results.length > 0
        ? _c(
            "div",
            _vm._l(_vm.results, function(contract, index) {
              return _c(
                "callout",
                {
                  key: index,
                  staticClass: "mb-3",
                  attrs: {
                    "border-color":
                      (contract.amendments || []).length > 0 ? "primary-1" : "",
                    "class-main": "bg-secondary-13",
                    "class-panel": "p-1",
                    "has-toggle": (contract.amendments || []).length > 0,
                    opened: _vm.isEditingGroup(contract)
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "edition",
                        fn: function() {
                          return _vm._l(contract.amendments, function(
                            amendment,
                            idx
                          ) {
                            return _c(
                              "callout",
                              {
                                key: idx,
                                attrs: {
                                  "class-main": "bg-white mb-2",
                                  "has-border": false,
                                  "has-toggle": false
                                }
                              },
                              [
                                _c("row", {
                                  attrs: {
                                    "contract-info": contract,
                                    "editing-numbers": _vm.isEditingGroup(
                                      contract
                                    ),
                                    "is-child": true,
                                    model: amendment,
                                    "number-suffix":
                                      _vm.amendmentSuffixDrafts[amendment.id] ||
                                      "",
                                    "number-value": _vm.parentNumberDraft
                                  },
                                  on: {
                                    remove: _vm.onRemoveContractHandler,
                                    "update-number-suffix": function($event) {
                                      return _vm.onAmendmentSuffixInput(
                                        amendment,
                                        $event
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          })
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c("row", {
                    attrs: {
                      "can-edit-number": _vm.canEditContractNumber,
                      "editing-numbers": _vm.isEditingGroup(contract),
                      model: contract,
                      "number-value": _vm.parentNumberDraft
                    },
                    on: {
                      "cancel-edit-numbers": _vm.cancelEditNumbers,
                      remove: _vm.onRemoveContractHandler,
                      "save-numbers": function($event) {
                        return _vm.onSaveNumbers(contract)
                      },
                      "toggle-edit-numbers": function($event) {
                        return _vm.onToggleEditNumbers(contract)
                      },
                      "update-number": _vm.onParentNumberInput
                    }
                  })
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "text-right mt-3" },
        [
          _vm.contractValidate
            ? _c("action-button", {
                staticClass: "mx-2",
                attrs: {
                  i: "fas fa-file-plus pr-1",
                  text: "Añadir",
                  variant: "success"
                },
                on: { click: _vm.onAddContractHandler }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }